<template>
  <v-row class="border-bottom align-center">
    <v-col cols="1">
      <ClosdFildersIcon :document="file" :signed-file="file.signedOnClosd"/>
    </v-col>
    <v-col cols="10">
      <template v-if="upload">
        <div class="d-flex align-center justify-space-between">
          <div class="fileName text-text-primary">
            {{ file.objectToPost.fileName }}
          </div>
          <app-filesize-display v-if="file.size"
                                class="fileSize text-text-placeholder"
                                :value="file.size"
          />
        </div>
        <div class="loadingBar-container pt-2">
          <div class="loadingBar-background"></div>
          <div class="loadingBar-bar" :style="{ width: `${file.progress}%` }"/>
        </div>
      </template>
      <template v-else>
        <div class="fileName">{{ file.objectToPost.fileName }}</div>
        <div class="fileSize">
          <app-filesize-display v-if="file.size"
                                class="fileSize text-text-placeholder"
                                :value="file.size"
          />
        </div>
      </template>
    </v-col>
    <v-col v-if="upload" cols="1" class="fileAction">
      <app-material-icon v-if="file.status === 'success'" name="check_circle" color="icon-success" filled />
      <app-material-icon v-if="file.status === 'error'" name="warning" color="icon-warning" filled />
    </v-col>
  </v-row>
</template>

<script>
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'

export default {
  name: 'ArchivesAddStep4File',
  components: { ClosdFildersIcon },
  props: {
    file: {
      type: Object,
      required: true,
    },
    upload: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
@import "@/scss/border-tokens";
@import "@/scss/typography-tokens";

.loadingBar-container {
  width: 100%;
  position: relative;

  .loadingBar-background {
    position: absolute;
    width: 100%;
    height: 6px;
    @include border-radius('border-radius-pill');
    background-color: rgb(var(--v-theme-surface-grey));
  }

  .loadingBar-bar {
    position: absolute;
    height: 6px;
    @include border-radius('border-radius-pill');
    background-color: rgb(var(--v-theme-surface-info-bold));
  }
}

.fileName {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
}

.fileSize {
  @include text('detail-md-regular');

  color: rgb(var(--v-theme-text-placeholder));
  white-space: nowrap;
}

.border-bottom {
  border-bottom: get-border();
}
</style>
